import './App.css';
import Home from './components/home';
import Memory from './components/memories';

// Props
const natkun = "Happy Birthday";

function App() {
  return (
    <div className="App">
      <Home tes={natkun} />
      <Memory></Memory>
    </div>
  );
}

export default App;




